import Repository from "./Repository";

const file_resource = "fileUpload";
export default {
  fileModel(payload) {
    const form= new FormData()
    form.append("file",payload.file)
    form.append("company_code",payload.company_code)
    return Repository.post(file_resource, form);
  },
};
